<template>
  <div class="bind-account">
    <div class="register-cont">
      <h1>绑定手机号</h1>
      <t-message v-show="isToastshow" theme="error" icon :duration="2000" :content="message" />
      <div class="user-register">
        <el-form :model="codeForm" :rules="codeRules" ref="codeForm" class="register-from">
          <el-form-item prop="phone">
            <el-input v-model="codeForm.phone" placeholder="请输入手机号" @focus="phoneFocus" :maxlength="11"></el-input>
          </el-form-item>
          <el-form-item prop="code" class="code-item">
            <el-input v-model="codeForm.code" placeholder="请输入验证码" @focus="clearVerify('codeForm', 'code')"
              @change="codeChange" :maxlength="6"></el-input>
            <div :class="[codeBtnVal == '获取验证码' ? 'get-code' : 'get-code2']" @click="clickCode">{{ codeBtnVal }}</div>
          </el-form-item>
        </el-form>
        <div class="btn" @click="register">
          {{ registerName }}
        </div>

        <p>
          根据《中华人民共和国网络安全法》要求，使用互联网服务需要进<br />行身份信息验证。请绑定手机号验证，感谢你的支持和理解。
        </p>
      </div>

      <p class="p3">还没有账号？<span @click="toRegister">立即注册</span></p>
    </div>
    <!--滑块验证-->
    <slider-verify ref="sliderVerify" @closeDialog="closeDialog" @success="onSuccess" @fail="onFail" @again="onAgain" />
  </div>
</template>

<script>
import { userLogin, getDynamicCode, bindEmail } from "@/../api";
import { zhugeTrack, comPop, jumpAfterLogin } from "@/utils/utils";
import { mapState, mapMutations } from "vuex";
import sliderVerify from "@/components/common/puzzleVerify";
export default {
  name: "",
  props: ["referUrl", "codeLogin"],
  components: {

    sliderVerify
  },
  watch: {
    "sliderResult": {
      handler(val) {
        if (val) {
          this.getCode(val)
        }
      },
      deep: true,
      immediate: true
    },
  },
  data() {
    return {
      selectFlag: false,
      passwordFlag: "password",
      codeBtnVal: "获取验证码",
      imgCodeErr: false,
      codeErr: false,
      registerName: "绑定并登录",
      codeForm: {
        phone: "",

        code: "",
        password: "",
      },
      codeRules: {
        phone: [
          { required: true, message: "请输入正确的手机号", trigger: "blur" },
          {
            pattern: /^1\d{10}$/,
            message: "手机号格式不正确",
            trigger: "blur",
          },
        ],

        code: [
          { required: true, message: "请输入动态验证码", trigger: "blur" },
          { min: 6, max: 6, message: "请输入动态验证码", trigger: "blur" },
          { validator: this.codeValidator },
        ],
        password: [
          { required: true, message: "请输入8-18位密码", trigger: "blur" },
          {
            pattern:
              /^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[_\-@&=.])[a-zA-Z0-9_\-@&=.]{8,18}$/i,
            message: "必须为8-18位数字、字母、常用符号(_-@&=.)组合",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState(["isToastshow", "message", "manyloginToast", "isShowSliderVerify", 'sliderResult']),
  },
  mounted() {

  },
  methods: {
    ...mapMutations(["toastshow", "toastHidden", "manyLoginToastshow"]),
    onSuccess() {},
    /* 滑动验证异常*/
    onAgain() {
      this.$message.error("滑动操作异常，请重试")
    },
    closeDialog() {},
    pwdvalidator(rule, value, callback) {
      if (this.pwdError) {
        return callback(new Error(this.pawErrMsg));
      } else {
        callback();
      }
    },

    // 去注册页面
    toRegister() {
      this.$router.push({
        name: "register",
        query: {
          refer: this.referUrl ? this.referUrl : undefined,
          codeLogin: this.codeLogin ? this.codeLogin : undefined,
        },
      });
    },
    show(message = "默认", duration = 3000) {
      this.toastshow(message);

      const toastTimer = setTimeout(() => {
        this.toastHidden();
        clearTimeout(toastTimer)
      }, duration);

    },
    // 显示、隐藏密码
    openPwd() {
      if (this.passwordFlag == "password") {
        this.passwordFlag = "text";
      } else {
        this.passwordFlag = "password";
      }
    },

    // 动态验证码校验
    codeValidator(rule, value, callback) {
      if (this.codeErr) {
        return callback(
          new Error("请输入正确验证码，连续输入错误，账号将被锁定")
        );
      } else {
        callback();
      }
    },
    // 清除手机验证
    phoneFocus() {
      this.clearVerify("codeForm", "phone");
      this.phoneHas = false;
    },
    //点击验证码
    clickCode() {

      if (this.codeBtnVal != "获取验证码") return;
      if (!this.codeForm.phone || this.codeForm.phone.length < 11) {
        this.$refs["codeForm"].validateField("phone");
        return;
      }
      localStorage.setItem('currUserPhone', this.codeForm.phone)
      this.isShowSliderVerifyHandle(true)
    },
    // 获取验证码
    getCode(validCode) {

      let _this = this;
      let params = {
        mobileOrEmail: this.codeForm.phone.trim(),
        vType: 1,
        messageType: 1,
        validCode: validCode
      };
      this.codeBtnVal = "发送中...";
      getDynamicCode(params).then((res) => {
        let data = res.data;
        if (data.success) {
          // 获取验证码成功
          let num = 60;
          var timer = setInterval(() => {
            if (num <= 0) {
              _this.codeBtnVal = "获取验证码";
              clearInterval(timer);
            } else {
              _this.codeBtnVal = num-- + "s";
            }
          }, 1000);
        } else {
          this.show(data.developerMsg);
          this.codeBtnVal = "获取验证码";
        }
      });
    },
    // 注册验证码登录
    register() {
      if (this.registerName != "绑定并登录") {
        return;
      }

      this.$refs["codeForm"].validate((valid) => {
        if (valid) {
          let did = zhuge.getDid();
          let sid = zhuge.getSid();
          let bindParams = {
            mobile: this.codeForm.phone,
            dynamicCode: this.codeForm.code,
            additional: did + "@" + sid,
            rememberme: "1",
            email: this.$route.query.email,
          };
          bindEmail(bindParams).then((res) => {
            this.registerName = "绑定中";
            if (res.data.code == 200) {
              // 注册成功后登录
              jumpAfterLogin(this.referUrl);
              zhugeTrack("Web_绑定并登录成功");
              this.registerName = "绑定并登录";
            } else if (res.data.code == 403) {
              //存储当前用户的错误次数
              this.codeErr = true;
              this.$refs["codeForm"].validateField("code");

              this.pwdError = true;
              this.pawErrMsg = "请输入正确验证码，连续输入错误，账号将被锁定";
              this.registerName = "绑定并登录";
            } else if (res.data.code == 423) {
              this.manyLoginToastshow();
              this.registerName = "绑定并登录";
            } else {
              this.show("绑定登录失败");
              this.registerName = "绑定并登录";
            }
          });
          zhugeTrack("Web_点击绑定");
        }
      });
    },
    // 清除单个表单项验证
    clearVerify(refName, item) {
      this.$refs[refName].clearValidate(item);
    },
    // 校验验证码更改时，移除错误校验提示
    codeChange() {
      this.codeErr = false;
    },
  },
  beforeDestroy() {
    // 清除二维码检验登录接口
    clearInterval(this.loginTime);
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1280px) {
  .register-cont {
    right: 120px !important;
  }
}

@media screen and (min-width: 1920px) {
  .register-cont {
    right: 440px !important;
  }
}

@media screen and (min-width: 1281px) and (max-width: 1919px) {
  .register-cont {
    right: 200px !important;
  }
}

.bind-account {
  ::v-deep input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px white inset !important;
  }

  .t-message {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -24px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #1d2129;

    height: 48px;
    background: #ffffff;
    box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08),
      0px 3px 6px -4px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    border: 1px solid #e5e6eb;
  }

  .toast {
    z-index: 999;
    position: absolute;
    top: 40%;
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 20px;
    z-index: 1000;
    left: 50%;
    transform: translateX(-50%);
    color: #fff;
    font-size: 26px;
    padding: 30px 71px;
    text-align: center;
    white-space: nowrap;
  }

  .register-cont {
    width: 464px;
    height: 520px;
    background: #ffffff;
    box-shadow: 0px 12px 40px 16px rgba(8, 25, 93, 0.03),
      0px 8px 20px 0px rgba(8, 25, 93, 0.06),
      0px 4px 8px 0px rgba(8, 25, 93, 0.08);
    border-radius: 8px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 200px;

    h1 {
      height: 32px;
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1d2129;
      line-height: 32px;
      margin: 48px auto 0px;
      text-align: center;
    }

    .tab-check {
      display: flex;
      margin-left: 48px;
    }

    .p1 {
      height: 24px;
      border-radius: 4px 4px 0px 0px;
      margin-right: 32px;
      line-height: 24px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 600;
      color: #165dff;
      cursor: pointer;

      &::after {
        content: "";
        width: auto;
        height: 3px;
        background: #165dff;
        border-radius: 4px 4px 0px 0px;
        display: block;
        margin-top: 7px;
      }
    }

    .p2 {
      height: 24px;

      cursor: pointer;
      border-radius: 4px 4px 0px 0px;
      margin-right: 32px;
      line-height: 24px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;

      color: #4e5969;

      &:hover {
        color: #165dff;
      }
    }
  }

  ::v-deep .user-register {
    p {
      span {
        color: #165dff !important;

        &:hover {
          color: #4080ff !important;
        }
      }
    }

    .get-code {
      color: #4e5969 !important;

      &:hover {
        color: #4080ff !important;
      }
    }
  }

  ::v-deep .register-from {
    margin-top: 40px;

    .el-form-item {
      margin-bottom: 24px;
    }

    .el-input__inner {
      width: 368px;
      height: 40px;
      background: rgba(255, 255, 255, 0.9);
      border-radius: 4px;
      line-height: 40px;

      padding-left: 16px;
      box-sizing: border-box;

      &:focus {
        border: 1px solid #165dff;
      }
    }

    .is-error {
      .el-input__inner {
        border: 1px solid #f53f3f;
      }

      .el-form-item__error {
        padding-top: 0px;
        height: 20px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #f53f3f;
        line-height: 20px;
      }
    }
  }

  ::v-deep .btn {
    background: #165dff;

    &:hover {
      background: #4080ff;
    }
  }

  ::v-deep .other-login {
    span {
      color: #165dff;

      &:hover {
        color: #4080ff !important;
      }
    }
  }

  .user-register {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-content: flex-start;

    .code-item {
      position: relative;

      ::v-deep .el-form-item__content {
        display: flex;
      }

      ::v-deep .el-input {
        display: flex;
        width: 240px;

        .el-input__inner {
          width: 240px;
          height: 40px;
          border-radius: 4px;
          line-height: 40px;
          overflow: hidden;
        }
      }

      .get-code {
        width: 112px;
        height: 40px;
        background: #e8f3ff;
        border-radius: 4px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 40px;
        text-align: center;
        margin-left: 16px;
        cursor: pointer;

        &:hover {
          color: #165dff;
        }
      }

      .get-code2 {
        width: 112px;
        height: 40px;
        background: #e8f3ff;
        border-radius: 4px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 40px;
        text-align: center;
        margin-left: 16px;

      }
    }

    .pwd-item {
      position: relative;

      .open-pwd {
        width: 14px;
        height: 14px;
        position: absolute;
        cursor: pointer;
        top: 50%;
        right: 19px;
        transform: translateY(-50%);
        opacity: 0.6;

        &:hover {
          opacity: 1;
        }

        i {
          line-height: 14px;
        }
      }

      .icon1 {
        background: url("../assets/login/icon／preview-close\(2\).png");
        background-size: 100% 100%;
        opacity: 1;
        width: 16px;
        height: 16px;
        background-size: cover;
      }

      .icon2 {
        background: url("../assets/login/icon／preview-open.png");
        background-size: 100% 100%;
        width: 16px;
        height: 16px;
        background-size: cover;
        opacity: 1;
      }
    }

    .btn {
      width: 368px;
      height: 44px;
      border-radius: 4px;
      margin-top: 8px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      letter-spacing: 0;
      cursor: pointer;
      border: none;
      outline: none;
      text-align: center;
      line-height: 44px;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      background-color: #165dff;

      &:hover {
        background-color: #4080ff;
      }
    }

    .disabled {
      background: #ccc !important;
      cursor: auto;

      &:hover {
        background: #ccc !important;
      }
    }

    p {
      height: 40px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #86909c;
      line-height: 20px;
      position: relative;
      padding-left: 8px;
      margin-top: 16px;

      &::before {
        content: "*";
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #86909c;
        line-height: 20px;
        position: absolute;
        top: 0;
        left: -5px;
      }
    }
  }

  .p3 {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4e5969;
    line-height: 22px;
    text-align: center;
    margin-top: 98px;

    span {
      color: #165dff;
      cursor: pointer;

      &:hover {
        color: #4080ff;
      }
    }
  }
}</style>
